import * as _ from 'underscore';
import { IAjax } from 'lib/Ajax';
import { CachedModelLoader } from 'lib/CachedModelLoader';
import UOM from 'lib/UOM';

import { PCCache } from 'data/PCCache';

import { CargoActivityType, CargoActivityTypeOptions } from 'data/models/CargoActivityType';
import { CargoCategory, CargoCategoryOptions } from 'data/models/CargoCategory';
import { Organization, OrganizationOptions } from 'data/models/Organization';
import { TradeRoute, TradeRouteOptions } from 'data/models/TradeRoute';

import { OrderableLookups, OrderableLookupsParams } from 'portcall/orderablelookups/model';

export interface TariffLookupsParams {
    id : number;
}

export function TariffLookups(
    loader : CachedModelLoader<Organization, OrganizationOptions>,
    ajax : IAjax,
    data : PCCache,
    orderableLookupsModel : <TItem extends { Url : () => string | null }, TData>(params : OrderableLookupsParams<TItem, TData>) => OrderableLookups<TItem>,
    { id } : TariffLookupsParams
) {
    const { model } = loader({ Id: id }, 30),
        CargoActivityLookups = orderableLookupsModel({
            supportsAdd: true,
            addClient: ajax.Url<CargoActivityType, CargoActivityTypeOptions>(() => model.CargoActivityTypesUrl() ?? ''),
            items: model.CargoActivityTypes.filter(t => t.Active()),
            cacheCollection: data.CargoActivityTypes,
            orderProp: t => t.DisplayOrder,
            itemFactory: order => new CargoActivityType({
                Id: 0,
                Active: true,
                Name: '--',
                DisplayOrder: order
            }),
            itemKey: i => i.Id(),
            deleteFn: (_client, draft) => draft.Active(false)
        }),
        TradeRouteLookups = orderableLookupsModel({
            supportsAdd: true,
            addClient: ajax.Url<TradeRoute, TradeRouteOptions>(() => model.TradeRoutesUrl() ?? ''),
            items: model.TradeRoutes.filter(t => t.Active()),
            cacheCollection: data.TradeRoutes,
            orderProp: t => t.DisplayOrder,
            itemFactory: order => new TradeRoute({
                Id: 0,
                Active: true,
                Name: '--',
                DisplayOrder: order
            }),
            itemKey: i => i.Id(),
            deleteFn: (_client, draft) => draft.Active(false)
        }),
        CargoCategoryLookups = orderableLookupsModel({
            supportsAdd: true,
            addClient: ajax.Url<CargoCategory, CargoCategoryOptions>(() => model.CargoCategoriesUrl() || ''),
            items: model.CargoCategories.filter(c => c.Active()),
            cacheCollection: data.CargoCategories,
            orderProp: c => c.DisplayOrder,
            itemFactory: order => new CargoCategory({
                Id: 0,
                Active: true,
                Name: '--',
                UOM: UOM.Ounce,
                DisplayOrder: order
            }),
            itemKey: c => c.Id(),
            deleteFn: (_client, draft) => draft.Active(false)
        }),
        UOMOptions = [] as { name : () => string, value : () => string }[];

    for (let uom in UOM.Name) {
        UOMOptions.push({ name: () => `${UOM.Name[uom]} (${uom})`, value: () => uom });
    }

    return {
        Model: model,
        CargoActivityLookups,
        TradeRouteLookups,
        CargoCategoryLookups,
        UOMOptions
    };
}
export type TariffLookups = ReturnType<typeof TariffLookups>;


// WEBPACK FOOTER //
// ./apps/portcall/tarifflookups/model.ts